/* Put an icon next to some text. The icon and text will be vertically centered,
with standard spacing between. */
<template>
  <span :class="className">
    <BaseIcon
      :name="getIcon"
      class="absolute left-0 icon-text__icon"
      v-if="this.iconBefore"
      :size="this.size"
    ></BaseIcon>
    <span>
      <slot></slot>
    </span>
    <BaseIcon
      :name="getIcon"
      class="absolute right-0 icon-text__icon"
      v-if="this.iconAfter"
      :size="this.size"
    ></BaseIcon>
  </span>
</template>

<script>
import BaseIcon from './BaseIcon.vue'
export default {
  name: 'BaseIconText',
  components: { BaseIcon },
  props: {
    size: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'inherit',
      validator: function (value) {
        return (
          ['primary', 'secondary', 'white', 'inherit'].indexOf(value) !== -1
        )
      },
    },
    iconBefore: {
      type: String,
      default: null,
    },
    iconAfter: {
      type: String,
      default: null,
    },
    inlineFlex: {
      type: Boolean,
      default: false,
    },
    semiBold: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    className() {
      return `icon-text icon-text--${this.color} ${
        (this.inlineFlex && 'icon-text--inline') || ' '
      } ${(this.iconBefore && 'icon-text--before') || ' '} ${
        (this.iconAfter && 'icon-text--after') || ' '
      } ${(this.semiBold && 'icon-text--semibold') || ' '}`
    },
    getIcon() {
      return this.iconBefore || this.iconAfter
    },
  },
}
</script>

<style lang="postcss">
.icon-text {
  @apply flex items-center relative tracking-wide;
}
.icon-text--inline {
  @apply inline-flex;
}
.icon-text--before {
  @apply pl-8;
}
.icon-text--after {
  @apply pr-8;
}
.icon-text--primary {
  @apply text-primary;
}
.icon-text--secondary {
  @apply text-secondary;
}
.icon-text--white {
  @apply text-white;
}
.icon-text--semibold {
  @apply font-semibold;
}
.icon-text--inherit {
  color: inherit;
}
.icon-text__icon {
}
.isActive .icon-text__icon {
  transform: rotate(45deg);
}
</style>
